import axios from "axios";
import axiosRetry from "axios-retry";
import Cookies from "universal-cookie";

var cookies = new Cookies();

export class HttpProvider {
  static instance;
  apiInstance;

  constructor() {
    this.apiInstance = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
    });
    axiosRetry(this.apiInstance, {
      retries: 1,
      retryDelay: (retryCount) => {
        return 5000;
      },
      shouldResetTimeout: true,
      retryCondition: (_error) => true,
    });
    this.apiInstance.interceptors.response.use(
      (response) => response
      // (error) => error
    );
  }

  static getInstance() {
    if (HttpProvider.instance) {
      cookies = new Cookies();
      return this.instance;
    } else {
      HttpProvider.instance = new HttpProvider();
      return HttpProvider.instance;
    }
  }

  async getSurveyVersion(survey_name) {
    return await this.apiInstance.get(`survey\\items\\${survey_name}`);
  }

  async submitData(survey_uid, data, token) {
    return await this.apiInstance.post(
      `survey\\${survey_uid}\\entries`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async createOrder(survey_entries_uid) {
    const data = { survey_entries_uid: survey_entries_uid };
    return await this.apiInstance.post(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getOrder() {
    return await this.apiInstance.get(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getProductsRecommendation(survey_entries_uid) {
    return await this.apiInstance.get(
      `product\\contraceptive\\recommendation\\${survey_entries_uid}`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async createNewOrderItem(order_uid, products_uid, sku_uid, sku_quantity) {
    const data = {
      products_uid: products_uid,
      sku_uid: sku_uid,
      quantity: sku_quantity,
    };
    return await this.apiInstance.post(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${order_uid}\\items`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async updateOrderItem(
    order_uid,
    data_uid,
    products_uid,
    sku_uid,
    sku_quantity
  ) {
    const data = {
      products_uid: products_uid,
      sku_uid: sku_uid,
      quantity: sku_quantity,
    };
    await this.apiInstance.delete(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${order_uid}\\items\\${data_uid}`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
    return await this.apiInstance.post(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${order_uid}\\items`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getShipmentProviders(order_uid) {
    return await this.apiInstance.get(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\${order_uid}\\shipment`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async checkCoupon(code) {
    return await this.apiInstance.get(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\coupons\\${code}`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async patchCouponUid(coupon_uid, order_uid) {
    const data = { coupons_uid: coupon_uid };
    return await this.apiInstance.patch(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${order_uid}`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async patchShippingProviderUid(shipping_uid, order_uid) {
    const data = { shipping_providers_uid: shipping_uid };
    return await this.apiInstance.patch(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${order_uid}`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async patchAddressesUid(addresses_uid, order_uid) {
    const data = { addresses_uid: addresses_uid };
    return await this.apiInstance.patch(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${order_uid}`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getStripeSetupIntent(method) {
    return await this.apiInstance.get(
      `payment\\stripe?method=${method}`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async postStripeData(orders_uid, setup_intent_id, paymentMethod = null) {
    var data = {
      orders_uid: orders_uid,
      currency: "eur",
      addresses_uid: cookies.get("invoice_address_uid"),
    };
    if (paymentMethod !== null) {
      data["payment_method"] = paymentMethod;
    } else if (setup_intent_id !== null) {
      data["setup_intent_id"] = setup_intent_id;
    }
    return await this.apiInstance.post(
      `payment\\stripe`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async storePaypalPayment(paypal_order_id, orders_uid) {
    const data = {
      paypal_order_id: paypal_order_id,
      orders_uid: orders_uid,
      addresses_uid: cookies.get("invoice_address_uid"),
    };
    return await this.apiInstance.post(
      `payment\\paypal`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async storeVorkassePayment(
    orders_uid,
    first_name,
    last_name,
    chosen_product_short,
    order_price
  ) {
    const data = {
      orders_uid: orders_uid,
      first_name: first_name,
      last_name: last_name,
      chosen_product_short: chosen_product_short,
      order_price: order_price,
      addresses_uid: cookies.get("invoice_address_uid"),
    };
    return await this.apiInstance.post(
      `payment\\vorkasse`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async confirmOrder(orders_uid) {
    return await this.apiInstance.patch(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${orders_uid}\\confirm`,
      {},
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getPillBrands() {
    return await this.apiInstance.get(
      `product\\contraceptive\\brands?name_short=`
    );
  }

  // MANAGE
  async createUser(profileData, type) {
    var data = {
      first_name: profileData.first_name,
      last_name: profileData.last_name,
      sex: "F",
      birthdate: "",
      phone: profileData.telephone,
    };
    if (type === "create") {
      if (window.sessionStorage.getItem("medq_survey_additional_data")) {
        const additionalData = JSON.parse(
          window.sessionStorage.getItem("medq_survey_additional_data")
        );
        if (additionalData.customer_dob !== undefined)
          data["birthdate"] = additionalData.customer_dob;
      }
    } else if (type === "update") {
      data["birthdate"] = profileData.birthdate;
    }

    return await this.apiInstance
      .post(
        `manage\\profile`,
        data,
        cookies.get("token")
          ? {
              headers: { Authorization: `Bearer ${cookies.get("token")}` },
            }
          : {
              withCredentials: true,
            }
      )
      .catch((error) => error);
  }

  async getAddressData(type) {
    return await this.apiInstance.get(
      `manage\\address?type=${type}`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getKitStatus() {
    return await this.apiInstance.get(
      `user\\kitcustomer`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getProfileAddressData() {
    return await this.apiInstance.get(
      `manage\\address`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async postAddressData(addressData, type, countriesUid) {
    const data = {
      countries_uid: countriesUid,
      name: addressData.first_name + " " + addressData.last_name,
      address: addressData.street,
      city: addressData.city,
      house_number: addressData.house_number,
      postal_code: addressData.postal_code,
      additional_address: addressData.address,
    };
    if (type === "package") {
      data["post_number"] = addressData.post_number;
      data["address"] = addressData.packing_station;
      data["house_number"] = addressData.number;
      data["additional_address"] = null;
    } else {
      data["post_number"] = null;
    }
    return await this.apiInstance.post(
      `manage\\address`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getCountry() {
    return await this.apiInstance.get(`manage\\address\\country`);
  }

  async getProfile() {
    return await this.apiInstance.get(
      `manage\\profile`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async deleteProfile() {
    return await this.apiInstance.delete(
      `manage\\profile`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getUser() {
    return await this.apiInstance.get(
      `manage\\profile\\user`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getConsent() {
    return await this.apiInstance.get(
      `manage\\consent`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async manageConsent(polls, marketing, personal) {
    const data = {
      polls: polls,
      marketing: marketing,
      personal: personal,
    };
    return await this.apiInstance.put(
      `manage\\consent`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async marketingConsent(marketing) {
    const data = {
      polls: true,
      marketing: marketing,
      personal: true,
    };
    return await this.apiInstance.put(
      `manage\\consent`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  // ADMINISTRATIVE
  async loginUser(identity, password) {
    const data = { identity: identity, password: password };
    return await this.apiInstance.post(
      `access\\login`,
      data
      // {
      //   withCredentials: true,
      // }

      // , {
      //   headers: { Authorization: `Bearer ${cookies.get("token")}` },
      // }
    );
  }

  async logoutUser() {
    return await this.apiInstance.post(
      `access\\logout`,
      null,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async refreshToken() {
    const data = {
      refresh_token: `${cookies.get("refresh_token")}`,
      grant_type: "refresh_token",
    };
    return await this.apiInstance.post(`access\\refresh`, data);
  }

  async registerUser(email, tos, invite_token) {
    const data = {
      email: email,
      tos: tos,
      invite_token: invite_token,
    };
    return await this.apiInstance.post(`access\\register`, data);
  }

  async registerFriend(email, tos, invite_token) {
    const data = {
      email: email,
      tos: tos,
      invite_token: invite_token,
    };
    return await this.apiInstance.post(`access\\register\\friend`, data);
  }

  async upgradeUser(email, tos) {
    /**
     * Upgrades anaonymous user to registered customer with his email address
     */
    const data = {
      email: email,
      tos: tos,
    };
    return await this.apiInstance.post(
      `access\\register`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async registerAnonymous() {
    const data = {
      tos: true,
    };
    return await this.apiInstance.post(`access\\register\\anonymous`, data);
  }

  async verifyUser() {
    var res = await this.apiInstance.get(
      `access\\verify\\email`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
    return res;
  }

  async setPassword(secret, verify, password, pfx) {
    const data = {
      secret: secret,
      verify: verify,
      password: password,
    };
    if (pfx !== "") data.pfx = pfx;
    return await this.apiInstance.post(
      `access\\verify\\email`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async verifyEmail(email) {
    return await this.apiInstance.get(`access\\reset\\password?email=${email}`);
  }

  async resetPassword(secret, verify, password) {
    const data = {
      secret: secret,
      verify: verify,
      password: password,
    };
    return await this.apiInstance.post(`access\\reset\\password`, data);
  }

  //Terms
  async getAGB() {
    return await this.apiInstance.get(`content\\terms\\de-DE`);
  }

  async getDatenschutz() {
    return await this.apiInstance.get(`content\\gdpr\\de-DE`);
  }

  async getImpressum() {
    return await this.apiInstance.get(`content\\legal\\de-DE`);
  }

  async getDFApp() {
    return await this.apiInstance.get(`content\\gdpr\\de-DE?app=True`);
  }

  async getOtcRecommendation() {
    return await this.apiInstance.get(
      `product\\otcs\\recommendation`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getOtcDescription(id) {
    return this.apiInstance.get(`content\\otcs\\${id}/de-DE`);
  }

  getAssetUrl(id) {
    return `${this.apiInstance.defaults.baseURL}\\content\\assets\\${id}`;
  }

  async getProducts() {
    return this.apiInstance.get(`product\\products`);
  }

  deleteOrderItem(order_uid, item_uid) {
    return this.apiInstance.delete(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\orders\\${order_uid}\\items\\${item_uid}`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async uploadVerificationFile(files, orderUid) {
    const formData = new FormData();
    formData.append("files", files[0].file);
    return await this.apiInstance.put(
      `manage\\id${orderUid ? "?orders_uid=" + orderUid : ""}`,
      formData,
      cookies.get("token")
        ? {
            headers: {
              Authorization: `Bearer ${cookies.get("token")}`,
            },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async checkVerificationStatus(orderUid) {
    return await this.apiInstance.get(
      `manage\\id`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async checkPhoneVerification() {
    return await this.apiInstance.get(
      `access\\verify\\phone`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async putPhoneForVerification(phone) {
    const data = {
      phone: phone,
    };

    return await this.apiInstance.put(
      `access\\verify\\phone`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async patchCodeForVerification(code, pfx) {
    const data = {
      verify: code,
      pfx: pfx,
    };
    return await this.apiInstance.patch(
      `access\\verify\\phone`,
      data,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }

  async getContraceptiveData(skuid) {
    return await this.apiInstance.get(`product\\contraceptive\\skus\\${skuid}`);
  }

  async getOctData(skuid) {
    return await this.apiInstance.get(`product\\otcs\\list\\${skuid}`);
  }

  async getProductType(productUid) {
    return await this.apiInstance.get(
      `product\\products?products_uid=${productUid}`
    );
  }

  async getCoupons() {
    return await this.apiInstance.get(
      `${process.env.REACT_APP_COMMERCE_API_VERSION}commerce\\coupons\\customers`,
      cookies.get("token")
        ? {
            headers: { Authorization: `Bearer ${cookies.get("token")}` },
          }
        : {
            withCredentials: true,
          }
    );
  }
}
